import { IComponentOptions } from "angular";
import { SelectMachinePartModalController } from "./controller";

export const vsComponentName = "selectMachinePartModal";
export const vsNgType = "component";

export const selectMachinePartModalOptions: IComponentOptions & {
  vsNgType: string;
  vsName: string;
} = {
  controller: SelectMachinePartModalController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    resolve: "<",
    modalInstance: "<",
  },
  vsNgType,
  vsName: vsComponentName,
};
